/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTicketDesc.vue?vue&type=template&id=f08f08c8&scoped=true"
import script from "./popAirdropTicketDesc.vue?vue&type=script&lang=js"
export * from "./popAirdropTicketDesc.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTicketDesc.vue?vue&type=style&index=0&id=f08f08c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08f08c8",
  null
  
)

export default component.exports